module.exports = __webpack_public_path__ + "img/ResidentOffice4.d2b14621.png";